<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-header class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="ClipboardIcon"
            size="20"
            class="text-primary mr-1"
          />
          <h4 class="mb-0">
            Strategy Doctor
          </h4>
        </div>
        <div>
          <b-button
            size="sm"
            variant="outline-primary"
            :disabled="loading"
            class="mr-50"
            @click="refresh"
          >
            <feather-icon icon="RefreshCwIcon" /> Yenile
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="loading"
            @click="scan"
          >
            <feather-icon icon="ActivityIcon" /> Scan
          </b-button>
        </div>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              Skor
            </div>
            <h3 :class="statusClass">
              {{ report ? formatNum(report.score, 0) : '-' }}
            </h3>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              Durum
            </div>
            <h5>
              <b-badge :variant="statusVariant(report && report.status)">
                {{ statusLabel(report && report.status) }}
              </b-badge>
            </h5>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              24s PnL
            </div>
            <h5 :class="summary.pnl24h >= 0 ? 'text-success' : 'text-danger'">
              {{ signedNum(summary.pnl24h, 2) }}
            </h5>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              WR / PF
            </div>
            <h5>
              {{ formatNum(summary.winRate24h, 1) }}% / {{ formatNum(summary.profitFactor24h, 2) }}
            </h5>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              Açık / Boş bot
            </div>
            <h5>
              {{ summary.openPositions || 0 }} / {{ summary.freeBots || 0 }}
            </h5>
          </b-col>
          <b-col
            cols="6"
            md="2"
            class="mb-1"
          >
            <div class="text-muted font-small-3">
              Reçete
            </div>
            <h5>
              {{ prescriptions.length }}
            </h5>
          </b-col>
        </b-row>
        <b-card
          no-body
          class="mb-2 border"
        >
          <b-card-body>
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
              <div>
                <h5 class="mb-25">
                  Setup Doktoru
                </h5>
                <div class="text-muted font-small-3">
                  Sermaye, bot, kaldıraç, risk ve TP/SL dengesini tek okumada değerlendirir.
                </div>
              </div>
              <b-badge
                v-if="setupHealth"
                :variant="setupHealthBadgeVariant(setupHealth.riskBand)"
              >
                {{ setupHealth.profile }} · {{ setupHealth.riskBand }}
              </b-badge>
            </div>
            <b-row>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Sermaye
                </div>
                <b-form-input
                  v-model="setupDraft.capitalUSDT"
                  type="number"
                  min="0"
                  step="10"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Bot
                </div>
                <b-form-input
                  v-model="setupDraft.botCount"
                  type="number"
                  min="1"
                  step="1"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Kaldıraç
                </div>
                <b-form-input
                  v-model="setupDraft.leverage"
                  type="number"
                  min="1"
                  step="1"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Risk %
                </div>
                <b-form-input
                  v-model="setupDraft.riskPct"
                  type="number"
                  min="0"
                  step="0.1"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  TP %
                </div>
                <b-form-input
                  v-model="setupDraft.tpPct"
                  type="number"
                  min="0"
                  step="0.1"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  SL %
                </div>
                <b-form-input
                  v-model="setupDraft.slPct"
                  type="number"
                  min="0"
                  step="0.1"
                  size="sm"
                />
              </b-col>
            </b-row>
            <b-row class="align-items-center mb-1">
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <div class="text-muted font-small-3 mb-25">
                  Reçete onay modu
                </div>
                <b-form-radio-group
                  v-model="setupDraft.recommendationApprovalMode"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  :options="approvalModeOptions"
                />
                <div class="text-muted font-small-3">
                  Kullanıcı isterse onaylar, isterse sistem seçili öneriyi otomatik işler.
                </div>
              </b-col>
            </b-row>
            <b-row class="align-items-end">
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Komisyon %
                </div>
                <b-form-input
                  v-model="setupDraft.commissionPct"
                  type="number"
                  min="0"
                  step="0.01"
                  size="sm"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-1"
              >
                <b-button
                  size="sm"
                  variant="primary"
                  :disabled="loading"
                  @click="evaluateSetupHealth"
                >
                  <feather-icon icon="ActivityIcon" /> Analiz Et
                </b-button>
              </b-col>
            </b-row>
            <div
              v-if="setupHealth"
              class="mt-1 border rounded bg-light p-1"
            >
              <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
                <div>
                  <strong>{{ setupProfileLabel(setupHealth.profile) }}</strong>
                  <div class="text-muted font-small-3">
                    Skor {{ formatNum(setupHealth.score, 0) }} · Risk {{ setupRiskBandLabel(setupHealth.riskBand) }}
                  </div>
                  <div class="text-muted font-small-3 mt-50">
                    {{ setupProfileSummary(setupHealth.profile)[0] }} · {{ setupActionHint(setupHealth.profile) }}
                  </div>
                </div>
                <b-badge :variant="setupHealthBadgeVariant(setupHealth.riskBand)">
                  {{ setupHealth.riskBand }}
                </b-badge>
              </div>
              <b-row>
                <b-col
                  cols="6"
                  md="3"
                  class="mb-1"
                >
                  <div class="text-muted font-small-3">
                    Beklenen trade
                  </div>
                  <strong>{{ formatNum(setupHealth.metrics.expectedTradeCount, 0) }}</strong>
                </b-col>
                <b-col
                  cols="6"
                  md="3"
                  class="mb-1"
                >
                  <div class="text-muted font-small-3">
                    Tahmini komisyon
                  </div>
                  <strong>{{ formatNum(setupHealth.metrics.estimatedCommission, 2) }}</strong>
                </b-col>
                <b-col
                  cols="6"
                  md="3"
                  class="mb-1"
                >
                  <div class="text-muted font-small-3">
                    Gerekli WR
                  </div>
                  <strong>{{ formatNum(setupHealth.metrics.requiredWinRate, 1) }}%</strong>
                </b-col>
                <b-col
                  cols="6"
                  md="3"
                  class="mb-1"
                >
                  <div class="text-muted font-small-3">
                    Gerekli avg win
                  </div>
                  <strong>{{ formatNum(setupHealth.metrics.requiredAvgWin, 2) }}</strong>
                </b-col>
              </b-row>
              <div class="mb-50">
                <b-badge
                  v-for="item in setupHealth.recommendations"
                  :key="item.profile"
                  class="mr-50 mb-50"
                  :variant="item.profile === setupHealth.profile ? 'light-primary' : 'light-secondary'"
                >
                  {{ item.title }} - {{ item.summary }}
                  <span
                    v-if="item.autoApproved"
                    class="ml-50"
                  >· auto-approved</span>
                </b-badge>
              </div>
              <div
                v-if="setupHealth.selectedRecommendation"
                class="border rounded bg-white p-1 mb-50"
              >
                <div class="d-flex align-items-center justify-content-between mb-50">
                  <strong>Seçili reçete</strong>
                  <b-badge variant="light-primary">
                    {{ setupHealth.selectedRecommendation.approvalMode }}
                  </b-badge>
                </div>
                <div>
                  <strong>{{ setupHealth.selectedRecommendation.title }}</strong>
                  <div class="text-muted font-small-3">
                    {{ setupHealth.selectedRecommendation.summary }}
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap align-items-end mb-50">
                <div
                  class="mr-1"
                  style="min-width: 220px;"
                >
                  <div class="text-muted font-small-3 mb-25">
                    Uygulanacak hedef
                  </div>
                  <b-form-select
                    v-model="selectedTargetId"
                    :options="targetOptions"
                    size="sm"
                  />
                </div>
                <div class="text-muted font-small-3">
                  Seçili hedefe reçete kaydı yazılır.
                </div>
              </div>
              <div
                v-if="setupHealth.scenarios && setupHealth.scenarios.length"
                class="border rounded bg-white p-1 mb-50"
              >
                <div class="text-muted font-small-3 mb-50">
                  Örnek kurulum okuması
                </div>
                <div
                  v-for="scenario in setupHealth.scenarios"
                  :key="scenario.label"
                  class="mb-25"
                >
                  <strong>{{ scenario.label }}</strong>
                  <div class="text-muted font-small-3">
                    {{ scenario.verdict }}
                  </div>
                </div>
              </div>
              <b-button
                v-if="setupHealth.selectedRecommendation && setupDraft.recommendationApprovalMode !== 'OFF'"
                size="sm"
                variant="success"
                class="mb-50"
                @click="applySelectedRecommendation"
              >
                <feather-icon icon="CheckIcon" /> Seçili reçeteyi uygula
              </b-button>
              <b-button
                v-if="setupHealth.selectedRecommendation && activeTarget && activeTarget.options && activeTarget.options.strategyDoctor && activeTarget.options.strategyDoctor.previousOptions"
                size="sm"
                variant="outline-warning"
                class="ml-50 mb-50"
                @click="rollbackSelectedRecommendation"
              >
                <feather-icon icon="RotateCcwIcon" /> Son değişikliği geri al
              </b-button>
              <b-button
                v-if="setupHealth.selectedRecommendation && activeTarget && (report && (report.status === 'RISKY' || report.status === 'ACTION_REQUIRED'))"
                size="sm"
                variant="outline-danger"
                class="ml-50 mb-50"
                @click="autoRecoverSelectedRecommendation"
              >
                <feather-icon icon="ShieldIcon" /> Auto-recovery
              </b-button>
              <div
                v-if="setupHealth.nextActions && setupHealth.nextActions.length"
                class="mb-50"
              >
                <div
                  v-for="action in setupHealth.nextActions"
                  :key="action.label"
                  class="d-flex align-items-start mb-25"
                >
                  <b-badge
                    variant="light-info"
                    class="mr-50"
                  >
                    {{ action.label }}
                  </b-badge>
                  <div class="text-muted font-small-3">
                    {{ action.value }}
                  </div>
                </div>
              </div>
              <div
                v-if="setupHealth.reasons.length"
                class="mb-50"
              >
                <div
                  v-for="reason in setupHealth.reasons.slice(0, 3)"
                  :key="reason"
                  class="text-muted font-small-3 mb-25"
                >
                  {{ reason }}
                </div>
              </div>
              <div
                v-if="setupHealth.warnings.length"
                class="text-muted font-small-3"
              >
                <div
                  v-for="warning in setupHealth.warnings.slice(0, 3)"
                  :key="warning"
                  class="mb-25"
                >
                  {{ warning }}
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
        <div
          v-if="exitHealth"
          class="border rounded bg-light p-1 mt-1"
        >
          <div class="d-flex flex-wrap align-items-center mb-1">
            <div>
              <strong>Exit health</strong>
              <div class="text-muted font-small-3">
                {{ exitHealth.modeReason }}
              </div>
              <div class="d-flex flex-wrap align-items-center mt-25">
                <b-badge
                  variant="light-primary"
                  class="mr-50 mb-25"
                >
                  Önerilen mod: {{ modeLabel(exitHealth.recommendedMode) }}
                </b-badge>
                <b-badge
                  v-if="exitHealth.avgWinLossCoverage !== null && exitHealth.avgWinLossCoverage !== undefined"
                  :variant="exitHealth.avgWinLossCoverage >= 1 ? 'light-success' : 'light-warning'"
                  class="mr-50 mb-25"
                >
                  Avg win / loss: {{ formatNum(exitHealth.avgWinLossCoverage, 2) }}x
                </b-badge>
              </div>
              <div
                v-if="guardianCoordinationSummary.length"
                class="text-muted font-small-3 mt-25"
              >
                {{ guardianCoordinationSummary[0] }}
              </div>
              <div
                v-for="line in exitHealth.reentryCooldownSummary || []"
                :key="line"
                class="mb-50"
              >
                <b-badge variant="light-info">
                  {{ line }}
                </b-badge>
              </div>
            </div>
            <b-badge
              variant="light-primary"
              class="ml-auto"
            >
              {{ modeLabel(exitHealth.recommendedMode) }}
            </b-badge>
          </div>
          <b-row>
            <b-col
              cols="6"
              md="3"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Avg win / loss
              </div>
              <strong>{{ exitHealth.avgWinLossCoverage === null || exitHealth.avgWinLossCoverage === undefined ? '-' : formatNum(exitHealth.avgWinLossCoverage, 2) }}x</strong>
              <div class="text-muted font-small-3">
                {{ exitHealth.avgWinLossCoverage >= 1 ? 'Kapsama yeterli' : 'Kapsama zayıf' }}
              </div>
            </b-col>
            <b-col
              cols="6"
              md="3"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Giveback baskisi
              </div>
              <strong>{{ givebackLabel(exitHealth.givebackPressure) }}</strong>
            </b-col>
            <b-col
              cols="6"
              md="3"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Partial / Trail
              </div>
              <strong>{{ formatNum(exitHealth.partialEnabledTargets || 0, 0) }} / {{ formatNum(exitHealth.trailEnabledTargets || 0, 0) }}</strong>
            </b-col>
            <b-col
              cols="6"
              md="3"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Step stop
              </div>
              <strong>{{ formatNum(exitHealth.stepEnabledTargets || 0, 0) }}</strong>
            </b-col>
          </b-row>
          <div class="text-muted font-small-3 mb-1">
            Real win / Micro win / Pozitif SL:
            <strong>{{ formatNum(exitHealth.realWinCount || 0, 0) }}</strong> /
            <strong>{{ formatNum(exitHealth.microWinCount || 0, 0) }}</strong> /
            <strong>{{ formatNum(exitHealth.positiveSlCount || 0, 0) }}</strong>
          </div>
          <div
            v-if="exitAnalytics"
            class="border rounded bg-white p-1 mb-1"
          >
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
              <strong>Exit analytics</strong>
              <div class="text-muted font-small-3">
                {{ formatNum((exitAnalytics.overview && exitAnalytics.overview.trades) || 0, 0) }} kapanış
              </div>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="4"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Family baskısı
                </div>
                <strong>{{ exitAnalyticsBucketKey(exitAnalytics.highlights && exitAnalytics.highlights.pressureFamily) }}</strong>
                <div class="text-muted font-small-3">
                  {{ exitAnalyticsBucketMeta(exitAnalytics.highlights && exitAnalytics.highlights.pressureFamily) }}
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Baskın close reason
                </div>
                <strong>{{ exitAnalyticsBucketKey(exitAnalytics.highlights && exitAnalytics.highlights.dominantCloseReason) }}</strong>
                <div class="text-muted font-small-3">
                  {{ exitAnalyticsBucketMeta(exitAnalytics.highlights && exitAnalytics.highlights.dominantCloseReason) }}
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Zayıf mod
                </div>
                <strong>{{ exitAnalyticsModeKey(exitAnalytics.highlights && exitAnalytics.highlights.weakestMode) }}</strong>
                <div class="text-muted font-small-3">
                  {{ exitAnalyticsBucketMeta(exitAnalytics.highlights && exitAnalytics.highlights.weakestMode) }}
                </div>
              </b-col>
            </b-row>
            <div
              v-if="exitAnalytics.warnings && exitAnalytics.warnings.length"
              class="text-muted font-small-3"
            >
              <div
                v-for="warning in exitAnalytics.warnings.slice(0, 3)"
                :key="warning"
                class="mb-50"
              >
                {{ warning }}
              </div>
            </div>
          </div>
          <div
            v-if="exitHealth.warnings && exitHealth.warnings.length"
            class="text-muted font-small-3"
          >
            <div
              v-for="warning in exitHealth.warnings.slice(0, 4)"
              :key="warning"
              class="mb-50"
            >
              {{ warning }}
            </div>
          </div>
          <div class="mt-1 d-flex flex-wrap align-items-center">
            <b-badge
              variant="light-info"
              class="mr-50 mb-25"
            >
              Baseline: {{ modeLabel(exitHealth.recommendedMode) }}
            </b-badge>
            <b-badge
              variant="light-secondary"
              class="mr-50 mb-25"
            >
              User override ile sapma izlenebilir
            </b-badge>
          </div>
        </div>
        <div
          v-if="guardianRows && guardianRows.length"
          class="border rounded bg-light p-1 mt-1"
        >
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
            <strong>Guardian coordination</strong>
            <div class="text-muted font-small-3">
              Recovery / close-follow / soft-exit
            </div>
          </div>
          <b-row>
            <b-col
              v-for="row in guardianRows"
              :key="row.metric"
              cols="6"
              md="4"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                {{ row.metric }}
              </div>
              <strong>{{ formatNum(row.value || 0, 0) }}</strong>
            </b-col>
          </b-row>
          <div
            v-if="guardianCoordinationSummary.length"
            class="text-muted font-small-3"
          >
            <div
              v-for="line in guardianCoordinationSummary"
              :key="line"
              class="mb-50"
            >
              {{ line }}
            </div>
          </div>
        </div>
        <div
          v-if="indicatorSelection"
          class="border rounded bg-light p-1 mt-1"
        >
          <div class="d-flex flex-wrap align-items-center mb-1">
            <div>
              <strong>Indicator selection</strong>
              <div class="text-muted font-small-3">
                {{ indicatorSelectionReasonLabel(indicatorSelection.reason) }}
              </div>
            </div>
            <b-badge
              :variant="indicatorSelection.changedRecommended ? 'light-warning' : 'light-success'"
              class="ml-auto"
            >
              {{ indicatorSelection.market || '-' }}
            </b-badge>
          </div>
          <b-row>
            <b-col
              cols="12"
              md="4"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Seçili / Aktif
              </div>
              <strong>{{ indicatorSelection.selectedName || '-' }}</strong>
              <div class="text-muted font-small-3">
                {{ indicatorSelection.selectedEngineKey || '-' }} · skor {{ formatNum(indicatorSelection.selectedScore, 3) }}
              </div>
              <b-badge
                v-if="stickySelectionSummary(indicatorSelection)"
                variant="light-info"
                class="mt-25"
              >
                {{ stickySelectionSummary(indicatorSelection) }}
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Outcome güveni
              </div>
              <strong>{{ indicatorSignalScopeLabel(indicatorSelection.signalScope) }}</strong>
              <div class="text-muted font-small-3">
                conf {{ formatNum(indicatorSelection.signalConfidence, 2) }} · W {{ formatNum(indicatorSelection.signalWeight, 2) }}
              </div>
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="mb-1"
            >
              <div class="text-muted font-small-3">
                Baskın rejim
              </div>
              <strong>{{ indicatorSelection.regimeLabel || 'Regime yok' }}</strong>
              <div class="text-muted font-small-3">
                {{ formatNum(indicatorSelection.regimeShare || 0, 0) }}% · {{ formatNum(indicatorSelection.regimeSignals || 0, 0) }} sinyal
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>

    <b-tabs pills>
      <b-tab
        title="Reçeteler"
        active
      >
        <b-card no-body>
          <b-table
            :items="prescriptions"
            :fields="prescriptionFields"
            responsive
            small
            show-empty
            empty-text="Aktif reçete yok."
          >
            <template #cell(severity)="data">
              <b-badge :variant="severityVariant(data.item.severity)">
                {{ severityLabel(data.item.severity) }}
              </b-badge>
              <div class="text-muted font-small-3">
                {{ data.item.category }}
              </div>
            </template>
            <template #cell(issue)="data">
              <strong>{{ data.item.title }}</strong>
              <div class="text-muted font-small-3">
                {{ data.item.message }}
              </div>
            </template>
            <template #cell(recommendation)="data">
              <div>{{ data.item.recommendation }}</div>
              <div
                v-if="prescriptionKnobs(data.item).length"
                class="mt-50"
              >
                <b-badge
                  v-for="(knob, knobIndex) in prescriptionKnobs(data.item)"
                  :key="`${data.item.id || data.index}-knob-${knobIndex}`"
                  variant="light-secondary"
                  class="mr-50 mb-50"
                >
                  {{ knobLabel(knob) }}
                </b-badge>
              </div>
              <div
                v-if="prescriptionPresets(data.item).length"
                class="mt-50"
              >
                <div
                  v-for="(preset, presetIndex) in prescriptionPresets(data.item)"
                  :key="`${data.item.id || data.index}-preset-${presetIndex}`"
                  class="text-muted font-small-3 mb-50"
                >
                  <strong>{{ preset.label }}</strong> · {{ preset.summary }}
                </div>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-tab>

      <b-tab title="Hedefler">
        <b-card no-body>
          <b-table
            :items="targetHealth"
            :fields="targetFields"
            responsive
            small
            show-empty
            empty-text="Hedef yok."
          >
            <template #cell(name)="data">
              <strong>{{ data.item.name }}</strong>
              <div class="text-muted font-small-3">
                {{ data.item.status }}
              </div>
            </template>
            <template #cell(pnl)="data">
              <span :class="data.item.pnl24h >= 0 ? 'text-success' : 'text-danger'">
                {{ signedNum(data.item.pnl24h, 2) }}
              </span>
              <div class="text-muted font-small-3">
                WR {{ formatNum(data.item.winRate24h, 1) }}% · PF {{ formatNum(data.item.profitFactor24h, 2) }}
              </div>
            </template>
            <template #cell(bots)="data">
              {{ data.item.runningBots }}/{{ data.item.botCount }}
              <div class="text-muted font-small-3">
                Boş {{ data.item.freeBots }} · Açık {{ data.item.openPositions }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-tab>

      <b-tab title="Botlar">
        <b-card no-body>
          <b-table
            :items="botHealth"
            :fields="botFields"
            responsive
            small
            show-empty
            empty-text="Bot yok."
          >
            <template #cell(bot)="data">
              <strong>{{ data.item.name }}</strong>
              <div class="text-muted font-small-3">
                {{ data.item.status }} · {{ data.item.mode }} · {{ data.item.targetName || '-' }}
              </div>
            </template>
            <template #cell(route)="data">
              {{ data.item.symbol || '-' }} / {{ data.item.timeframe || '-' }}
              <div class="text-muted font-small-3">
                {{ data.item.indicator || '-' }}
              </div>
            </template>
            <template #cell(pnl)="data">
              <span :class="data.item.realizedPnl >= 0 ? 'text-success' : 'text-danger'">
                {{ signedNum(data.item.realizedPnl, 2) }}
              </span>
              <div class="text-muted font-small-3">
                {{ formatNum(data.item.capitalCurrent, 2) }} / {{ formatNum(data.item.capitalAllocated, 2) }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-tab>

      <b-tab title="Guardian">
        <b-card no-body>
          <b-table
            :items="guardianRows"
            :fields="guardianFields"
            responsive
            small
            show-empty
          />
        </b-card>
      </b-tab>

      <b-tab title="İndikatörler">
        <b-card no-body>
          <b-table
            :items="indicatorHealth"
            :fields="indicatorFields"
            responsive
            small
            show-empty
            empty-text="İndikatör verisi yok."
          >
            <template #cell(name)="data">
              <strong>{{ data.item.name }}</strong>
              <div class="text-muted font-small-3">
                {{ data.item.family || '-' }} · {{ data.item.engineKey || '-' }}
              </div>
              <div class="text-muted font-small-3">
                {{ indicatorSignalScopeLabel(data.item.signalScope) }} · conf {{ formatNum(data.item.signalConfidence, 2) }} · {{ data.item.regimeLabel || 'Regime yok' }}
              </div>
            </template>
            <template #cell(active)="data">
              <b-badge :variant="data.item.active ? 'success' : 'secondary'">
                {{ data.item.active ? 'Aktif' : 'Pasif' }}
              </b-badge>
            </template>
            <template #cell(metrics)="data">
              Score {{ formatNum(data.item.avgScore, 3) }} · Final {{ formatNum(data.item.overallScore, 3) }}
              <div class="text-muted font-small-3">
                WR {{ formatNum(data.item.avgWinRate, 1) }}% · EV {{ formatNum(data.item.avgNetEv, 3) }}
              </div>
              <div class="text-muted font-small-3">
                {{ data.item.signalNote || 'neutral' }} · rejim {{ formatNum(data.item.regimeShare || 0, 0) }}%
              </div>
            </template>
          </b-table>
        </b-card>
      </b-tab>

      <b-tab title="Entry Kalite">
        <b-card no-body>
          <b-card-body>
            <b-row>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Sinyal
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.signals, 0) }}
                </h4>
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Açıldı
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.openedRate, 1) }}%
                </h4>
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Blok
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.blockedRate, 1) }}%
                </h4>
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  İyi kaçan
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.goodSkippedRate, 1) }}%
                </h4>
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  Kötü açılan
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.badOpenedRate, 1) }}%
                </h4>
              </b-col>
              <b-col
                cols="6"
                md="2"
                class="mb-1"
              >
                <div class="text-muted font-small-3">
                  TP önce SL
                </div>
                <h4 class="mb-0">
                  {{ formatNum(entryOverview.tpBeforeSlRate, 1) }}%
                </h4>
              </b-col>
            </b-row>
            <div
              v-if="entryGuidanceText"
              class="d-flex flex-wrap align-items-center justify-content-between p-1 mb-1 border rounded bg-light"
            >
              <div class="d-flex align-items-center mr-1">
                <b-badge :variant="Number(entryGuidance.weightFactor || 1) >= 1 ? 'light-success' : 'light-warning'">
                  Guidance
                </b-badge>
                <div class="ml-1">
                  <strong>{{ entryGuidanceBucket }}</strong>
                  <div class="text-muted font-small-3">
                    {{ entryGuidanceText }}
                  </div>
                </div>
              </div>
              <div class="text-muted font-small-3">
                W {{ formatNum(entryGuidance.weightFactor || 1, 2) }}
                · ΔS {{ signedNum(entryGuidance.scoreDelta || 0, 2) }}
                · ΔScore {{ signedNum(entryGuidance.minEntryScoreDelta || 0, 2) }}
                · ΔRR {{ signedNum(entryGuidance.minRemainingRewardRiskDelta || 0, 2) }}
              </div>
            </div>
            <b-row
              v-if="entryActionRows.length"
              class="mb-1"
            >
              <b-col
                v-for="item in entryActionRows"
                :key="item.id"
                cols="12"
                xl="4"
                class="mb-1"
              >
                <div class="border rounded bg-light p-1 h-100">
                  <div class="d-flex align-items-center mb-50">
                    <b-badge :variant="severityVariant(item.severity)">
                      {{ severityLabel(item.severity) }}
                    </b-badge>
                    <strong class="ml-50">{{ item.title }}</strong>
                  </div>
                  <div class="text-muted font-small-3 mb-50">
                    {{ item.message }}
                  </div>
                  <div
                    v-if="prescriptionKnobs(item).length"
                    class="mb-50"
                  >
                    <b-badge
                      v-for="(knob, knobIndex) in prescriptionKnobs(item)"
                      :key="`${item.id}-entry-knob-${knobIndex}`"
                      variant="light-secondary"
                      class="mr-50 mb-50"
                    >
                      {{ knobLabel(knob) }}
                    </b-badge>
                  </div>
                  <div
                    v-if="prescriptionPresets(item).length"
                    class="text-muted font-small-3 mb-50"
                  >
                    <div
                      v-for="(preset, presetIndex) in prescriptionPresets(item)"
                      :key="`${item.id}-entry-preset-${presetIndex}`"
                      class="mb-50"
                    >
                      <strong>{{ preset.label }}</strong> · {{ preset.summary }}
                    </div>
                  </div>
                  <div class="font-small-3">
                    {{ item.recommendation }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                cols="12"
                lg="6"
                class="mb-1"
              >
                <b-table
                  :items="entryDecisionRows"
                  :fields="entryDecisionFields"
                  responsive
                  small
                  show-empty
                  empty-text="Decision module verisi yok."
                >
                  <template #cell(bucket)="data">
                    <strong>{{ data.item.bucket }}</strong>
                  </template>
                  <template #cell(openedRate)="data">
                    {{ formatNum(data.item.openedRate, 1) }}%
                  </template>
                  <template #cell(blockedRate)="data">
                    {{ formatNum(data.item.blockedRate, 1) }}%
                  </template>
                  <template #cell(goodSkippedRate)="data">
                    {{ formatNum(data.item.goodSkippedRate, 1) }}%
                  </template>
                  <template #cell(badOpenedRate)="data">
                    {{ formatNum(data.item.badOpenedRate, 1) }}%
                  </template>
                </b-table>
              </b-col>
              <b-col
                cols="12"
                lg="6"
                class="mb-1"
              >
                <b-table
                  :items="entryFamilyRows"
                  :fields="entryFamilyFields"
                  responsive
                  small
                  show-empty
                  empty-text="Family verisi yok."
                >
                  <template #cell(bucket)="data">
                    <strong>{{ data.item.bucket }}</strong>
                  </template>
                  <template #cell(openedRate)="data">
                    {{ formatNum(data.item.openedRate, 1) }}%
                  </template>
                  <template #cell(blockedRate)="data">
                    {{ formatNum(data.item.blockedRate, 1) }}%
                  </template>
                  <template #cell(goodSkippedRate)="data">
                    {{ formatNum(data.item.goodSkippedRate, 1) }}%
                  </template>
                  <template #cell(badOpenedRate)="data">
                    {{ formatNum(data.item.badOpenedRate, 1) }}%
                  </template>
                  <template #cell(guidance)="data">
                    <strong>{{ formatNum((data.item.guidance && data.item.guidance.weightFactor) || 1, 2) }}</strong>
                    <div class="text-muted font-small-3">
                      {{ (data.item.guidance && data.item.guidance.note) || 'neutral' }}
                    </div>
                    <div class="text-muted font-small-3">
                      ΔS {{ signedNum((data.item.guidance && data.item.guidance.scoreDelta) || 0, 2) }} · ΔScore {{ signedNum((data.item.guidance && data.item.guidance.minEntryScoreDelta) || 0, 2) }}
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-table
              class="mt-1"
              :items="entryRecentRows"
              :fields="entryRecentFields"
              responsive
              small
              show-empty
              empty-text="Recent outcome yok."
            >
              <template #cell(symbol)="data">
                <strong>{{ data.item.symbol }}</strong>
                <div class="text-muted font-small-3">
                  {{ data.item.side || '-' }} · {{ data.item.family || '-' }}
                </div>
              </template>
              <template #cell(decisionStatus)="data">
                <b-badge variant="light-primary">
                  {{ data.item.decisionStatus || 'DETECTED' }}
                </b-badge>
              </template>
              <template #cell(decisionModule)="data">
                <strong>{{ recentDecisionLabel(data.item) }}</strong>
                <div class="text-muted font-small-3">
                  {{ recentDecisionContext(data.item) }}
                </div>
              </template>
              <template #cell(signalMfePct)="data">
                {{ formatNum(data.item.signalMfePct, 2) }}
                <div class="text-muted font-small-3">
                  {{ recentOutcomeDetail(data.item) }}
                </div>
              </template>
              <template #cell(signalMaePct)="data">
                {{ formatNum(data.item.signalMaePct, 2) }}
              </template>
              <template #cell(detectedAt)="data">
                {{ formatDate(data.item.detectedAt) }}
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab title="Geçmiş">
        <b-card no-body>
          <b-table
            :items="history"
            :fields="historyFields"
            responsive
            small
            show-empty
            empty-text="Doctor geçmişi yok."
          >
            <template #cell(status)="data">
              <b-badge :variant="statusVariant(data.item.status)">
                {{ statusLabel(data.item.status) }}
              </b-badge>
            </template>
            <template #cell(createdAt)="data">
              {{ formatDate(data.item.createdAt) }}
            </template>
            <template #cell(summary)="data">
              {{ historyPrescriptionCount(data.item) }} reçete
            </template>
          </b-table>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BBadge, BButton, BCard, BCardBody, BCardHeader, BCol, BFormInput, BFormRadioGroup, BFormSelect, BRow, BTab, BTable, BTabs,
} from 'bootstrap-vue'
import {
  indicatorRecentDecisionContext,
  indicatorRecentDecisionLabel,
  outcomeMetricsDetail,
  stickySelectionSummary as buildStickySelectionSummary,
} from '@/utils/signalOutcomePresentation'
import { exitGovernorModeLabel } from '@/utils/exitGovernorModes'
import {
  setupHealthActionHint,
  setupHealthProfileSummary,
  setupHealthBadgeVariant as resolveSetupHealthBadgeVariant,
  setupProfileLabel as resolveSetupProfileLabel,
  setupRiskBandLabel as resolveSetupRiskBandLabel,
} from '@/utils/setupDoctorPresentation'

export default {
  name: 'StrategyDoctorIndex',
  components: {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BFormInput,
    BFormRadioGroup,
    BFormSelect,
    BRow,
    BTab,
    BTable,
    BTabs,
  },
  data() {
    return {
      prescriptionFields: [
        { key: 'severity', label: 'Durum' },
        { key: 'issue', label: 'Teşhis' },
        { key: 'recommendation', label: 'Reçete' },
      ],
      targetFields: [
        { key: 'name', label: 'Hedef' },
        { key: 'pnl', label: '24s' },
        { key: 'bots', label: 'Bot' },
        { key: 'realizedPnl', label: 'Toplam PnL' },
      ],
      botFields: [
        { key: 'bot', label: 'Bot' },
        { key: 'route', label: 'Route' },
        { key: 'openPositions', label: 'Açık' },
        { key: 'pnl', label: 'PnL' },
        { key: 'lastError', label: 'Hata' },
      ],
      guardianFields: [
        { key: 'metric', label: 'Metrik' },
        { key: 'value', label: 'Değer' },
      ],
      indicatorFields: [
        { key: 'name', label: 'İndikatör' },
        { key: 'active', label: 'Durum' },
        { key: 'edgeCount', label: 'Edge' },
        { key: 'exits', label: 'Exit' },
        { key: 'metrics', label: 'Metrik' },
      ],
      entryDecisionFields: [
        { key: 'bucket', label: 'Modül' },
        { key: 'signals', label: 'Sinyal' },
        { key: 'openedRate', label: 'Açıldı' },
        { key: 'blockedRate', label: 'Blok' },
        { key: 'goodSkippedRate', label: 'İyi Kaçan' },
        { key: 'badOpenedRate', label: 'Kötü Açılan' },
      ],
      entryFamilyFields: [
        { key: 'bucket', label: 'Family' },
        { key: 'signals', label: 'Sinyal' },
        { key: 'openedRate', label: 'Açıldı' },
        { key: 'blockedRate', label: 'Blok' },
        { key: 'goodSkippedRate', label: 'İyi Kaçan' },
        { key: 'badOpenedRate', label: 'Kötü Açılan' },
        { key: 'guidance', label: 'Guidance' },
      ],
      entryRecentFields: [
        { key: 'symbol', label: 'Sembol' },
        { key: 'decisionStatus', label: 'Durum' },
        { key: 'decisionModule', label: 'Modül' },
        { key: 'signalMfePct', label: 'MFE' },
        { key: 'signalMaePct', label: 'MAE' },
        { key: 'detectedAt', label: 'Tarih' },
      ],
      historyFields: [
        { key: 'createdAt', label: 'Tarih' },
        { key: 'status', label: 'Durum' },
        { key: 'score', label: 'Skor' },
        { key: 'summary', label: 'Özet' },
      ],
      setupDraft: {
        capitalUSDT: 3400,
        botCount: 30,
        leverage: 38,
        riskPct: 1.5,
        tpPct: 2.4,
        slPct: 1.2,
        commissionPct: 0.06,
        recommendationApprovalMode: 'OFF',
      },
      selectedTargetId: null,
      approvalModeOptions: [
        { text: 'Kapalı', value: 'OFF' },
        { text: 'Kullanıcı', value: 'USER' },
        { text: 'Sistem', value: 'SYSTEM' },
      ],
    }
  },
  computed: {
    report() { return this.$store.getters['strategyDoctor/report'] },
    history() { return this.$store.getters['strategyDoctor/history'] || [] },
    loading() { return this.$store.getters['strategyDoctor/loading'] },
    summary() { return (this.report && this.report.summary) || {} },
    prescriptions() { return (this.report && this.report.prescriptions) || [] },
    targetHealth() { return (this.report && this.report.targetHealth) || [] },
    botHealth() { return (this.report && this.report.botHealth) || [] },
    indicatorHealth() { return (this.report && this.report.indicatorHealth) || [] },
    indicatorSelection() { return (this.report && this.report.indicatorSelection) || null },
    exitHealth() { return (this.report && this.report.exitHealth) || null },
    exitAnalytics() { return (this.report && this.report.exitAnalytics) || null },
    entryQuality() { return (this.report && this.report.entryQuality) || null },
    setupHealth() { return this.$store.getters['strategyDoctor/setupHealth'] || null },
    entryOverview() { return (this.entryQuality && this.entryQuality.overview) || {} },
    entryGuidance() { return (this.entryQuality && this.entryQuality.guidance) || {} },
    entryGuidanceBucket() {
      return (this.entryQuality && this.entryQuality.filters && this.entryQuality.filters.family)
        ? `${this.entryQuality.filters.family} guidance`
        : 'Genel guidance'
    },
    entryGuidanceText() {
      const note = this.entryGuidance && this.entryGuidance.note
        ? String(this.entryGuidance.note).replace(/_/g, ' ')
        : ''
      return note
        ? `${note} · ${this.formatNum(this.entryGuidance.samples || 0, 0)} sinyal`
        : ''
    },
    entryDecisionRows() { return ((this.entryQuality && this.entryQuality.byDecisionModule) || []).slice(0, 5) },
    entryFamilyRows() { return ((this.entryQuality && this.entryQuality.byFamily) || []).slice(0, 5) },
    entryRecentRows() { return ((this.entryQuality && this.entryQuality.recent) || []).slice(0, 10) },
    entryActionRows() { return ((this.entryQuality && this.entryQuality.prescriptions) || []).slice(0, 3) },
    targetOptions() {
      const rows = this.targetHealth || []
      return [{ text: 'Hedef seç', value: null }, ...rows.map(row => ({ text: `${row.name} (#${row.id})`, value: row.id }))]
    },
    activeTarget() {
      const rows = this.targetHealth || []
      if (this.selectedTargetId) return rows.find(row => row.id === this.selectedTargetId) || null
      return rows.find(row => row.status === 'ACTIVE') || rows[0] || null
    },
    guardianRows() {
      const g = (this.report && this.report.guardianHealth) || {}
      return [
        { metric: 'FAILED 24s', value: g.failed24h || 0 },
        { metric: 'SKIPPED 24s', value: g.skipped24h || 0 },
        { metric: 'Soft exit 24s', value: g.softExit24h || 0 },
        { metric: 'Recovery öneri', value: g.recoverySuggested24h || 0 },
        { metric: 'Recovery açılan', value: g.recoveryApplied24h || 0 },
        { metric: 'Recovery boş bot', value: g.recoveryFreeBots || 0 },
      ]
    },
    guardianCoordinationSummary() {
      const lines = []
      const g = (this.report && this.report.guardianHealth) || {}
      const exitHealth = this.exitHealth || {}
      if (exitHealth.modeReason) lines.push(exitHealth.modeReason)
      if ((g.recoveryBlocked24h || 0) > 0) {
        lines.push(`Rec. bekle: ${this.formatNum(g.recoveryBlocked24h || 0, 0)}`)
      }
      if ((g.recoverySuggested24h || 0) > (g.recoveryApplied24h || 0)) {
        lines.push(`Rec. öneri/uyg: ${this.formatNum(g.recoverySuggested24h || 0, 0)} / ${this.formatNum(g.recoveryApplied24h || 0, 0)}`)
      }
      if ((g.softExit24h || 0) > 0) {
        lines.push(`Soft exit: ${this.formatNum(g.softExit24h || 0, 0)}`)
      }
      if ((g.recoveryFreeBots || 0) > 0) {
        lines.push(`Recovery bot: ${this.formatNum(g.recoveryFreeBots || 0, 0)} boş`)
      }
      return lines.slice(0, 3)
    },
    statusClass() {
      if (!this.report) return ''
      if (this.report.status === 'ACTION_REQUIRED') return 'text-danger'
      if (this.report.status === 'RISKY') return 'text-warning'
      if (this.report.status === 'WATCH') return 'text-info'
      return 'text-success'
    },
  },
  created() {
    this.refresh()
    this.$store.dispatch('strategyDoctor/getHistory')
  },
  methods: {
    refresh() {
      this.$store.dispatch('strategyDoctor/getOverview')
    },
    scan() {
      this.$store.dispatch('strategyDoctor/scan')
    },
    evaluateSetupHealth() {
      this.$store.dispatch('strategyDoctor/evaluateSetupHealth', this.setupDraft)
    },
    applySelectedRecommendation() {
      const selected = this.setupHealth && this.setupHealth.selectedRecommendation
      const target = this.activeTarget
      if (!selected || !target) return
      this.setupDraft.recommendationApprovalMode = selected.approvalMode
      const modeMap = {
        SAFE: 'PROTECT_PROFIT',
        BALANCED: 'BALANCED',
        FAST: 'GROW_PROFIT',
      }
      const options = {
        ...(target.options || {}),
        strategyDoctor: {
          previousOptions: target.options || {},
          recommendationApprovalMode: selected.approvalMode,
          selectedRecommendationProfile: selected.profile,
          selectedRecommendationTitle: selected.title,
        },
        exitGovernor: {
          ...((target.options && target.options.exitGovernor) || {}),
          mode: modeMap[selected.profile] || 'BALANCED',
        },
      }
      this.$store.dispatch('targets/update', {
        id: target.id,
        body: { options },
      }).then(() => {
        this.evaluateSetupHealth()
      })
    },
    rollbackSelectedRecommendation() {
      const target = this.activeTarget
      if (!target) return
      this.$store.dispatch('targets/rollbackStrategyDoctor', target.id).then(() => {
        this.evaluateSetupHealth()
      })
    },
    autoRecoverSelectedRecommendation() {
      const target = this.activeTarget
      if (!target) return
      this.$store.dispatch('strategyDoctor/autoRecover', { targetId: target.id }).then(() => {
        this.$store.dispatch('targets/getDetail', target.id)
        this.evaluateSetupHealth()
      })
    },
    formatNum(value, digits = 2) {
      const n = Number(value)
      if (!Number.isFinite(n)) return '-'
      return n.toLocaleString('tr-TR', { minimumFractionDigits: digits, maximumFractionDigits: digits })
    },
    signedNum(value, digits = 2) {
      const n = Number(value)
      if (!Number.isFinite(n)) return '-'
      return `${n >= 0 ? '+' : ''}${this.formatNum(n, digits)}`
    },
    statusVariant(status) {
      if (status === 'ACTION_REQUIRED') return 'danger'
      if (status === 'RISKY') return 'warning'
      if (status === 'WATCH') return 'info'
      return 'success'
    },
    statusLabel(status) {
      if (status === 'ACTION_REQUIRED') return 'Müdahale'
      if (status === 'RISKY') return 'Riskli'
      if (status === 'WATCH') return 'Dikkat'
      if (status === 'HEALTHY') return 'Sağlıklı'
      return '-'
    },
    severityVariant(severity) {
      if (severity === 'CRITICAL') return 'danger'
      if (severity === 'RISK') return 'warning'
      if (severity === 'WATCH') return 'info'
      return 'secondary'
    },
    severityLabel(severity) {
      if (severity === 'CRITICAL') return 'Müdahale'
      if (severity === 'RISK') return 'Risk'
      if (severity === 'WATCH') return 'Dikkat'
      return 'Bilgi'
    },
    formatDate(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('tr-TR')
    },
    recentDecisionLabel(item) {
      return indicatorRecentDecisionLabel(item)
    },
    recentDecisionContext(item) {
      return indicatorRecentDecisionContext(item, this.formatNum)
    },
    recentOutcomeDetail(item) {
      return outcomeMetricsDetail(item, this.formatNum)
    },
    stickySelectionSummary(item) {
      return buildStickySelectionSummary(item, this.formatNum)
    },
    parseJson(value, fallback) {
      if (!value) return fallback
      if (typeof value === 'object') return value
      try { return JSON.parse(value) } catch { return fallback }
    },
    prescriptionKnobs(item) {
      return ((item && item.meta && item.meta.knobs) || []).slice(0, 4)
    },
    prescriptionPresets(item) {
      return ((item && item.meta && item.meta.presets) || []).slice(0, 2)
    },
    knobKeyLabel(key) {
      if (key === 'minEntryScore') return 'Min Score'
      if (key === 'minRemainingRewardRisk') return 'Min RR'
      if (key === 'latePenalty') return 'Late Penalty'
      if (key === 'familyWeight') return 'Family Weight'
      if (key === 'confirmationStrictness') return 'Confirm'
      if (key === 'sameSideLock') return 'Same Side'
      if (key === 'exposureStrictness') return 'Exposure'
      return String(key || 'Knob')
    },
    knobLabel(knob) {
      if (!knob) return ''
      const key = this.knobKeyLabel(knob.key)
      const direction = knob.direction === 'UP' ? 'up' : 'down'
      const delta = Number(knob.delta)
      const deltaText = Number.isFinite(delta) && delta > 0 ? ` ${this.formatNum(delta, 2)}` : ''
      return `${key} ${direction}${deltaText}`
    },
    modeLabel(mode) {
      return exitGovernorModeLabel(mode)
    },
    setupHealthBadgeVariant(band) {
      return resolveSetupHealthBadgeVariant(band)
    },
    setupProfileLabel(profile) {
      return resolveSetupProfileLabel(profile)
    },
    setupRiskBandLabel(band) {
      return resolveSetupRiskBandLabel(band)
    },
    setupProfileSummary(profile) {
      return setupHealthProfileSummary(profile)
    },
    setupActionHint(profile) {
      return setupHealthActionHint(profile)
    },
    givebackLabel(value) {
      if (value === 'TIGHT') return 'Siki'
      if (value === 'LOOSE') return 'Genis'
      if (value === 'BALANCED') return 'Dengeli'
      return '-'
    },
    indicatorSignalScopeLabel(value) {
      if (value === 'INDICATOR') return 'Indicator'
      if (value === 'BLENDED') return 'Blend'
      return 'Family'
    },
    indicatorSelectionReasonLabel(value) {
      const text = String(value || '')
      if (text.startsWith('held_current_near_tie_better_context')) return 'Aktif indikatör yakın skorda daha net context taşıyor'
      if (text.startsWith('switched_to_top_ranked')) return 'En güçlü aday seçildi'
      if (text.startsWith('already_top_ranked')) return 'Aktif indikatör zaten lider'
      if (text.startsWith('no_ranked_indicator')) return 'Seçilebilir indikatör yok'
      if (text.includes('stickyConfidence') || text.includes('stickyAgeH')) {
        const ageMatch = text.match(/stickyAgeH=([0-9.]+)/)
        const confMatch = text.match(/stickyConfidence=([0-9.]+)/)
        const age = ageMatch ? Number(ageMatch[1]) : null
        const conf = confMatch ? Number(confMatch[1]) : null
        const ageText = Number.isFinite(age) ? `${this.formatNum(age, 1)} saat` : null
        const confText = Number.isFinite(conf) ? `${this.formatNum(conf, 2)} güven` : null
        const bits = [ageText, confText].filter(Boolean)
        return bits.length ? `Sticky seçim decay: ${bits.join(' · ')}` : 'Sticky seçim decay bilgisiyle değerlendirildi'
      }
      return text || '-'
    },
    exitAnalyticsBucketKey(bucket) {
      return (bucket && bucket.key) || '-'
    },
    exitAnalyticsModeKey(bucket) {
      return bucket && bucket.key ? this.modeLabel(bucket.key) : '-'
    },
    exitAnalyticsBucketMeta(bucket) {
      if (!bucket) return '-'
      return `${this.formatNum(bucket.trades || 0, 0)} trade · loss ${this.formatNum(bucket.lossRate || 0, 0)}% · micro ${this.formatNum(bucket.microWinRate || 0, 0)}%`
    },
    historyPrescriptionCount(item) {
      return this.parseJson(item.prescriptionsJson, []).length
    },
  },
}
</script>
